<template>
  <div style="margin-top: -10px; padding-bottom: 4px">
    <div
      v-for="item in tempMessageList"
      :key="item.uuid"
      class="message-list sent-message"
    >
      <el-avatar>
        {{ localNickname.charAt(0) }}
      </el-avatar>
      <div class="info" style="margin-right: 14px;">
          <span v-if="!item.failed" class="time-view">
            Sending...
          </span>
          <span v-else class="undelivered-message time-view">
            <i class="el-icon-warning-outline"></i> Not Delivered
          </span>
        <div class="message" v-html="item.m" />
        <ChatMessageTagItems v-if="item.wt" :item="item" :tempMessage="true"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ChatMessageTagItems from '@/components/Lesson/Chatbox/ChatMessageTagItems';

export default {
  components: { ChatMessageTagItems },
  props: {
    tempMessageList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      //
    };
  },
  computed: {
    ...mapState(['localNickname'])
  }
};
</script>
